import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Mail, Mic2, Play, Radio } from "lucide-react";
import { fadeUp } from "@/lib/motion";

const LINES = [
  {
    icon: Radio,
    title: "Advance listening",
    body: "Embeds, private streams and watermarked press plays — considered for reviews and New Music Friday.",
  },
  {
    icon: Play,
    title: "Premieres",
    body: "First-listen features and release-day coverage for singles, albums and videos.",
  },
  {
    icon: Mic2,
    title: "Interviews",
    body: "Long-form conversations with artists, producers and executives — focused on the craft, not the gossip.",
  },
];

export default function RhythmPress() {
  return (
    <section id="press" className="mx-auto max-w-7xl px-5 pt-16 sm:pt-24">
      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }}>
        <p className="font-rhythm-mono text-[11px] uppercase tracking-[0.22em] text-[#F3F1ED]">
          Press &amp; professional inquiries
        </p>
        <h2 className="mt-3 font-rhythm-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl">
          Work with The Rhythm Report
        </h2>
      </motion.div>

      <div className="mt-9 grid gap-6 md:grid-cols-3">
        {LINES.map((l, idx) => (
          <motion.div
            key={l.title}
            data-testid={`rhythm-press-card-${idx}`}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
            className="rhythm-card rounded-3xl p-7"
          >
            <l.icon className="h-5 w-5 text-[#F3F1ED]" />
            <h3 className="mt-4 font-rhythm-display text-lg font-bold uppercase tracking-snug">
              {l.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-white/65">{l.body}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        className="rhythm-card mt-6 flex flex-wrap items-center justify-between gap-6 rounded-3xl p-7"
      >
        <div>
          <p className="font-garamond text-xl italic text-white/85">
            For advance listening, premieres, interviews and press inquiries:
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.18em] text-white/45">
            Music submissions go through the form above — everything else starts with an email.
          </p>
        </div>
        <a
          data-testid="rhythm-press-email-btn"
          href="mailto:Morganwilliams1428@gmail.com?subject=The%20Rhythm%20Report%20—%20Press%20inquiry"
          className="inline-flex items-center gap-2 rounded-full bg-[#F3F1ED] px-6 py-3 text-xs font-bold uppercase tracking-[0.18em] text-[#0B0A0F] transition-transform duration-300 hover:translate-x-1"
        >
          <Mail className="h-4 w-4" /> Email the desk
        </a>
      </motion.div>
    </section>
  );
}
